export const TOOLBAR_BUTTON_SIZE = 48;
export const DEFAULT_FONT_SIZE = '24px';
export const BLACK_COLOR = '#42526E';
export const GREY_COLOR = '#ECEDF0';
